<ev-page-header />
<main class="not-found">
  <i aria-hidden="true" class="pi pi-link not-found__icon"></i>
  <h1 class="not-found__heading">{{ labels.heading }}</h1>
  <p class="not-found__body">{{ labels.body }}</p>
</main>
